import BusyButton from 'scoreboard/components/busy-button'
import icon from 'scoreboard/components/icon'
import deviceType from 'scoreboard/components/device-type'

const RefreshButton = BusyButton.extend({

	/**
	 * @param {Object} options.actionsContainer if the refresh button is contained within a
	 * list's .action-container, this is the refrence to that .action-container
	 */
	initialize(options = {}) {
		BusyButton.prototype.initialize.apply(this, arguments)
		this.actionsContainer = options.actionsContainer
	},

	loading() {
		BusyButton.prototype.loading.apply(this, arguments)
		this.resetClasses()
		this.$el.addClass('is-loading is-hovered')
		this.actionsContainer && this.actionsContainer.css('display', 'block')
	},

	_addExtraMarkup() {
		this.$('.error-holder, .check-holder').remove()
		this.$el.append(
			`<span class="check-holder">${icon('approved')}</span>
			<span class="error-holder">${icon('widget-empty-state')}</span>`)
		if (this.$('.icon-refresh').length == 0) {
			this.$el.append(icon('refresh'))
			this.removeRefreshIcon = true
		}
	},

	done(instadone) {
		let startDoneAnimation = () => {
			this.$('.icon-refresh').addClass('is-not-displayed')
			this.resetClasses()
			this.$el.addClass('is-loading is-done is-hovered')
		}

		let endDoneAnimation = () => {
			if (this.state == 'done') {
				this.disable()
			}
			this.trigger('animation-complete')
			this.$('.icon-refresh').removeClass('is-not-displayed')
			this.$el.removeClass('is-hovered')
			this.toggle(true)

			if (this.removeRefreshIcon) {
				this.$('.icon-refresh').remove()
			}

			this.actionsContainer && this.actionsContainer.css('display', '')
		}

		this.$('.check-holder').one('transitionend', () => endDoneAnimation())

		// Firefox has a difficult time cycling the checkmark without waiting
		// an extra split second before doing so.
		// https://github.com/SpiderStrategies/Scoreboard/issues/30021
		if(deviceType.firefox) {
			setTimeout(() => startDoneAnimation(), 10)
			return
		}

		startDoneAnimation()
		instadone && endDoneAnimation()
	},

	instadone() {
		this.enable()
		this.loading()
		process.nextTick(() => this.done(true))
	},

	error() {
		this.state = 'error'
		this.resetClasses()
		this.$el.addClass('has-error')
	},

	resetClasses() {
		this.$el.removeClass('is-done is-loading has-error is-hovered')
	}
})

export default RefreshButton

RefreshButton.__filename__ = 'components/refresh-button.js'
